import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AssetTypeManagePage } from '../../../components/AssetTypeManagePage'

const searchSchema = z.object({
  tab: z.enum(['overview', 'properties', 'settings']).default('overview').catch('overview'),
  // Spec 2026-10-09-04: the hierarchy card's mode.
  tree: z.enum(['inheritance', 'children']).optional().catch(undefined),
})

export const Route = createFileRoute('/$org/asset-types/$assetTypeUid')({
  validateSearch: searchSchema,
  component: AssetTypeManage,
})

function AssetTypeManage() {
  return <AssetTypeManagePage />
}